export const CONFERENCE_INFO = {
    alwaysVisible: ['recording'],
    autoHide: [
        'highlight-moment',
        'subject',
        'android-pip-button',
        'conference-timer',
        'raised-hands-count',
        'participants-count',
        'e2ee',
        'transcribing',
        'video-quality',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle',
        'toggle-camera-button',
        'sound-settings-button',
        'chat-button',
    ]
};
